import React from "react";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="row">
        <div className="col-12">
          <p>
            Have any suggestions/feedback or want to volunteer?{" "}
            <a target="_blank" href="https://forms.gle/DfhTSryzSYUYoaW18">
              Contact Us
            </a>
          </p>
        </div>
        {/* <div className='col-12 text-center'>
          <span>Parth Arora</span> <a href='https://www.linkedin.com/in/parth-arora-007274aa/'><i className='fa fa-linkedin'></i></a>
          <span>Ashutosh Ranjan</span> <a href='https://www.linkedin.com/in/ashutosh-ranjan-2170711b6/'><i className='fa fa-linkedin'></i></a>
          <span>Aditya Saxena</span> <a href='https://www.linkedin.com/in/aditya-saxena-2aa22616b/'><i className='fa fa-linkedin'></i></a>
          <span>Pulkit Aggarwal</span> <a href='https://www.linkedin.com/in/pulkit07/'><i className='fa fa-linkedin'></i></a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
